import { SettingsContext } from "contexts/settingsContext";
import { useCallback, useContext, useEffect, useState } from "react";
import useSettings from './useSettings'

import Decimal from "decimal.js";
import TelegramProvider, { useTelegram } from "contexts/TelegramContext";
import useAxios from "./useAxios";
import { useQuery } from "@tanstack/react-query";

const useUserQuest = (questType: number) => {
    const { settings } = useSettings();
    const { callApi } = useAxios()
    const { data: userQuest } = useQuery({
        enabled: !!settings?.token,
        queryKey: [
            'UserQuest', settings?.token, questType],
        queryFn: async () => {
            const nfts = await callApi('get', `/user/quest?questType=${questType ===0? 'DAILY' : 'PARTNER'}`) as any
            return nfts;
        },
        staleTime: 1000 * 60 * 5,
    });
    return {
        userQuest
    }
};

export default useUserQuest;
